import { useState } from 'react'
import supabase from '../config/SupabaseClient'
import { Eye, EyeOff } from 'lucide-react'

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const Auth = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [role, setRole] = useState('seller')
  const [isLogin, setIsLogin] = useState(true)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [displayName, setDisplayName] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setMessage(null)
    setLoading(true)

    if (isLogin) {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      })
      if (error) setError(error.message)
    } else {
      const roleMap = {
        seller: "seller",
        buyer: "buyer",
        driver: "driver"
      };

      try {
        const res = await fetch(`${API}/api/admin/create-user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email,
            password,
            full_name: displayName,
            display_name: displayName,
            role: roleMap[role]
          })
        })
        const data = await res.json()
        if (!res.ok || data.error) {
          setError(data.error || 'Registration failed')
        } else {
          setMessage('Registration successful! You can now log in.')
          setIsLogin(true)
          setPassword('')
          setDisplayName('')
        }
      } catch (err) {
        setError(err.message || 'An error occurred during registration')
      }
    }

    setLoading(false)
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{isLogin ? 'Access Your Intelligence Core' : 'Initialize Your Core'}</h2>
        <p className="auth-subtitle">
          {isLogin
            ? 'Sign in to manage your knowledge base and unlock AI-powered analysis'
            : 'Sign up to build your secure logistics intelligence network'}
        </p>

        {error && <p className="auth-error">{error}</p>}
        {message && <p className="auth-message">{message}</p>}

        <form onSubmit={handleSubmit} className="auth-form">
          {!isLogin && (
            <>
              <div className="input-group">
                <label htmlFor="displayName">Display Name</label>
                <input
                  type="text"
                  id="displayName"
                  value={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                  placeholder="enter your display name"
                  className="auth-input"
                  required
                />
              </div>

              <div className="input-group">
                <label htmlFor="role">Account Type</label>
                <select
                  id="role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  className="auth-input"
                >
                  <option value="seller">Seller</option>
                  <option value="buyer">Buyer</option>
                  <option value="driver">Driver</option>
                </select>
              </div>
            </>
          )}

          <div className="input-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="enter your email"
              className="auth-input"
              required
            />
          </div>

          <div className="input-group" style={{ position: 'relative' }}>
            <label htmlFor="password">Password</label>
            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="enter your password"
                className="auth-input"
                style={{ width: '100%', paddingRight: '40px' }}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '12px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#64748b',
                  display: 'flex',
                  alignItems: 'center',
                  padding: 0
                }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Processing...' : (isLogin ? 'Continue With Mail ➔' : 'Create Account ➔')}
          </button>
        </form>

        <p className="auth-toggle">
          {isLogin ? "Don't have an account? " : "Already have an account? "}
          <span onClick={() => setIsLogin(!isLogin)}>
            {isLogin ? 'Sign Up' : 'Sign In'}
          </span>
        </p>
        <p className="auth-encryption-notice">
          Your data is encrypted and secure. We never share your information with third parties.
        </p>
      </div>
    </div>
  )
}

export default Auth
